export default {
  search: {
    title: '人才搜索',
    tab: '人才搜索'
  },
  pool: {
    title: '人才库',
    tab: '人才库',
    potential: '人才库-潜在候选人'
  },
  title: {
    add: '创建新人才库',
    edit: '编辑人才库',
    tip: '提示'
  },
  label: {
    groupName: '人才库名称',
    groupVisibility: '可见性',
    parentGroup: '上级人才库',
    parentGroupTip: '(如有)',
    groupFilterDetail: '详情',
    total: '总数',
    authOwner: '可见范围',
    role: '角色',
    recruiter: '招聘人员',
    roleAccess: '角色可见范围',
    recruiterAccess: '招聘人员可见范围',
    noData: '暂无数据',
    access: '可见范围',
    groupAssign: '可见范围:',
    private: '私有'
  },
  GROUP_VISIBILITY: {
    PUBLIC: '公开',
    PRIVATE: '私有'
  },
  message: {
    assignSuccess: '分配成功',
    assignFailed: '分配失败，请重试'
  }
}
